import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { WA_LABEL, fmtDate } from "../SuperHeader";
import { Stat } from "../useAdminFetch";

export default function OverviewTab({ detail }) {
  const { company, admin, counts, wa_state, recent_activity } = detail;
  const wa = WA_LABEL[wa_state] || WA_LABEL.none;
  return (
    <div className="grid lg:grid-cols-3 gap-4" data-testid="overview-tab">
      <Card className="p-5 border-slate-200 lg:col-span-2 space-y-4">
        <dl className="grid sm:grid-cols-2 gap-3 text-sm">
          <div><dt className="text-xs text-slate-500">Registered</dt><dd data-testid="overview-registered">{fmtDate(company.created_at)}</dd></div>
          <div><dt className="text-xs text-slate-500">Plan</dt><dd className="capitalize">{company.plan || "—"}</dd></div>
          <div><dt className="text-xs text-slate-500">Company Admin</dt><dd data-testid="overview-admin">{admin ? `${admin.name} · ${admin.email}` : "No admin"}</dd></div>
          <div><dt className="text-xs text-slate-500">WhatsApp health</dt><dd><Badge className={wa.cls} data-testid="overview-wa">{wa.text}</Badge></dd></div>
          {company.status === "suspended" && (
            <div className="sm:col-span-2 p-3 rounded-lg bg-rose-50 border border-rose-100 text-rose-800 text-xs">
              Suspended {fmtDate(company.suspended_at)}{company.suspend_reason ? ` — ${company.suspend_reason}` : ""}
            </div>
          )}
        </dl>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
          <Stat label="Users" value={counts.users} testid="overview-users" />
          <Stat label="Contacts" value={counts.contacts} testid="overview-contacts" />
          <Stat label="Leads" value={counts.leads} testid="overview-leads" />
          <Stat label="Conversations" value={counts.conversations} testid="overview-conversations" />
          <Stat label="Campaigns" value={counts.campaigns} testid="overview-campaigns" />
        </div>
      </Card>
      <Card className="p-5 border-slate-200">
        <h3 className="font-semibold text-slate-900 mb-2">Recent activity</h3>
        {recent_activity.length === 0 ? <p className="text-xs text-slate-500">No recorded activity yet.</p> : (
          <ul className="space-y-2 text-xs" data-testid="overview-activity">
            {recent_activity.map((a, i) => (
              <li key={i} className="border-b border-slate-100 pb-1.5">
                <div className="font-medium text-slate-800">{a.action.replaceAll("_", " ")}</div>
                <div className="text-slate-500">{a.actor_email || "system"} · {fmtDate(a.at)}</div>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
